import {setStore, getStore} from '@/util/store'
import {diff} from '@/util/util'
import website from '@/config/website'

const isFirstPage = website.isFirstPage;
const tagWel = website.fistPage;
const tagObj = {
  label: '', // 标题名称
  value: '', // 标题的路径
  params: '', // 标题的路径参数
  query: '', // 标题的参数
  meta: {}, // 额外参数
  group: [] // 分组
}

// 处理首个标签
function setFistTag(list) {
  if (list.length === 1) {
    list[0].close = false;
  } else {
    list.forEach(ele => {
      if (ele.value === tagWel.value && isFirstPage === false) {
        ele.close = false
      } else {
        ele.close = true
      }
    })
  }
}
const navs = {
  state: {
    tagList: getStore({name: 'tagList'}) || [],
    tag: getStore({name: 'tag'}) || tagObj,
    tagWel: tagWel
  },
  actions: {},
  mutations: {
    ADD_TAG: (state, action) => {
      state.tag = action;
      setStore({name: 'tag', content: state.tag})
      if (state.tagList.some(ele => diff(ele, action))) return
      // 健康浏览器路径屏蔽导航栏tag
      // if(action.value.indexOf('/desk/detail') == -1){
        state.tagList.push(action)
      // }
      setFistTag(state.tagList);
      setStore({name: 'tagList', content: state.tagList})
    },
    DEL_TAG: (state, action) => {
      state.tagList = state.tagList.filter(item => {
        return !diff(item, action);
      })
      setFistTag(state.tagList);
      setStore({name: 'tagList', content: state.tagList})
    },
    DEL_ALL_TAG: (state) => {
      if (state.tag.value.indexOf('/desk/index') >= 0){
        let list = [state.tagWel];
        state.tagList = state.tagList.filter(item => {
          // eslint-disable-next-line eqeqeq
          if (item.value.indexOf('/desk/detail') == -1 && item.value != state.tagWel.value) {
            list.push(item);
          }
        })
        state.tagList = list;
        setFistTag(state.tagList);
        setStore({name: 'tagList', content: state.tagList})
      } else {
        state.tagList = [state.tagWel];
        setStore({name: 'tagList', content: state.tagList})
      }
    },
    DEL_TAG_OTHER: (state) => {
      state.tagList = state.tagList.filter(item => {
        if (state.tag.value.indexOf('/desk/detail') >= 0){
          if (item.value === state.tag.value) {
            return true;
          // eslint-disable-next-line eqeqeq
          } else if (state.tag.value.indexOf('/desk/detail') == -1) {
            return true;
          }
        } else {
          if (item.value === state.tag.value) {
            return true;
          } else if (!website.isFirstPage && item.value === website.fistPage.value) {
            return true;
          }
        }
      })
      setFistTag(state.tagList);
      setStore({name: 'tagList', content: state.tagList})
    },
    SET_TAG_LIST(state, tagList) {
      state.tagList = tagList;
      setStore({name: 'tagList', content: state.tagList})
    }
  }
}
export default navs



// WEBPACK FOOTER //
// ./src/store/modules/tags.js